import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getHighlights, getTasksSummaryText } from '@wix/ambassador-asa-highlights-v1-highlights/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { HighlightsClientBase } from './HighlightsClientBase';
export class HighlightsClient extends HttpBaseClient(HighlightsClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getHighlightsImpl", getHighlights);
    _defineProperty(this, "getTaskSummaryImpl", getTasksSummaryText);
  }
}
//# sourceMappingURL=HighlightsClientHttp.js.map